/* CUSTOM JS */

document.addEventListener('DOMContentLoaded', function () {
  // Trying to fix some bug with opacity never reveal --> Trigger resize to trigger reveal
  window.dispatchEvent(new Event('resize'));
});